<ng-container *transloco="let t;">
  <div class="content-area-wrapper overflow-visible template-view container-xxl p-0">
    <div class="filters-wrapper card mb-0 savefiltersSidebar" [hidden]="!savefiltersShowHide">
      <!--save filter Component  -->
      <!-- save filters main Sidebar (Filter) -->
      <core-sidebar class="sidebar-left" name="todo-sidebar-main" overlayClass="body-content-overlay"
        collapsibleSidebar="bs-gt-lg">
        <!-- Main Sidebar -->
        <div class="main-sidebar sidebar">
          <div class="sidebar-content flex-column todo-sidebar">
            <div class="todo-app-menu">
              <div class="d-flex justify-content-between align-items-center px-2 pt-1">
                <h5 class="font-small-3 mb-0 text-secondary saveFilterTabHeadline mt-25">{{ t('Save filters selection icon tooltip (documents) - Save filters') }}</h5>
                <i class="feather icon-chevrons-left font-small-4 cursor-pointer"
                  (click)="savefiltersShowHideClick()"></i>
              </div>
              <div class="sidebar-menu-list pt-2">
                <div class="list-group list-group-filters">
                  @for(filter of savedFiltersList$ | async; track filter) {
                  <a class="list-group-item list-group-item-action mb-0 d-flex justify-content-between align-items-center"
                      [ngClass]="{'active-filter': (selectedSavedFilterId$ | async) === filter.id}">
                    <div (click)="onSelectedSavedFilterChange(filter.id)" class="d-flex align-items-center">
                      <img [src]="(selectedSavedFilterId$ | async) === filter.id 
                                          ? '../../../../../assets/images/contract-card-images/filters-blob.png' 
                                            : '../../../../../assets/images/contract-card-images/filter-blob-gray.png'"
                        class="rounded-circle saveFilterTabIcon" alt="Card image" />
                      <small class="align-middle saveFilterTabTitle" [ngClass]="{'text-secondary': (selectedSavedFilterId$ | async) === filter.id, 'text-muted': (selectedSavedFilterId$ | async) !== filter.id}">{{ filter.name }}</small>
                    </div>
                  </a>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--/ Main Sidebar -->
      </core-sidebar>
      <span class="cursor-pointer font-small-3 p-2 manageSaveFilterIcon" (click)="manageSavedFilters()"><i
          data-feather="settings" [size]="12" class=" me-25"></i>{{ t('Manage filters modal title (Manage filters modal) - Manage filters') }} </span>
      <!--/ save filters main Sidebar -->
      <!--save filter Component  -->
    </div>
    <!-- content-right -->
    <div class="content-right" [ngClass]="{'content-right-100': savefiltersShowHide}">


      <div class="todo-app-list">
        <div class="app-fixed-search">
          <div class="d-flex justify-content-start align-items-center w-100">
            <div class="sidebar-toggle d-none d-lg-none ms-1">
              <button class="btn p-0" (click)="savefiltersShowHideClick()">
                <i class="feather icon-menu"></i>
              </button>
            </div>
  
            <div class="d-flex align-content-center justify-content-between w-100">
              <div class="input-group input-group-merge">
                <div class="input-group-prepend">
                  <span class="input-group-text me-25"><i class="feather icon-search text-muted"></i></span>
                </div>
                  <input
                          type="text"
                          class="form-control"
                          id="document-search"
                          #searchInput
                          [placeholder]="t('Search input placeholder - (Contract control section) - Search contracts')"
                          aria-label="Search..."
                          [(ngModel)]="searchPhrase"
                          (keyup.enter)="onSearchApply(searchInput.value)"
                          aria-describedby="document-search"
                  />
              </div>
            </div>
          </div>
          <div class="listview-icons-container">
            @if ((savedFiltersList$ | async).length > 0) {
                <a class="p-25 d-flex align-content-center icon-hover justify-content-center" placement="auto"
                  triggers="hover" [ngbTooltip]="t('Save filters selection icon tooltip (documents) - Save filters')"
                  (click)="savefiltersShowHideClick()">
                  <i class="doc-filter-icon font-medium-1" [ngClass]="{'activeIcons': savefiltersShowHide}">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-linecap="round" stroke-linejoin="round" width="20" height="20" stroke-width="1.5">
                      <path d="M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                      <path d="M6 4v4" />
                      <path d="M6 12v8" />
                      <path d="M10 16a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                      <path d="M12 4v10" />
                      <path d="M12 18v2" />
                      <path d="M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                      <path d="M18 4v1" />
                      <path d="M18 9v11" />
                    </svg>
                  </i>
                </a>
            }
            <a class="p-50 pe-75 me-75 d-flex align-content-center icon-hover justify-content-center border-end"
              placement="auto" triggers="hover" ngbTooltip="Filters" (click)="filtersShowHideClick()">
              <i class="me-0 font-medium-1 feather icon-filter align-middle"
                [ngClass]="{'activeIcons': filtersShowHide}"></i>
            </a>
            <a class="p-0 d-flex align-content-center hidden icon-hover me-1 justify-content-center" placement="auto"
              triggers="hover" [ngbTooltip]="t('Data view selection icon tooltip (documents) - Data view')">
              <i class="feather font-medium-1 icon-pie-chart"
                [ngClass]="{'activeIcons': (activeView$ | async) === DocumentViewVariantEnum.graph_view || (activeView$ | async) === DocumentViewVariantEnum.chart_view}"
                (click)="toggleViews(DocumentViewVariantEnum.graph_view)"></i>
            </a>
            <a class="p-0 d-flex align-content-center hidden icon-hover me-1 justify-content-center" placement="auto"
              triggers="hover" [ngbTooltip]="t('Folder view selection icon tooltip (documents) - Folder view')">
              <i class="feather font-medium-1 icon-folder"
                [ngClass]="{'activeIcons': (activeView$ | async) === DocumentViewVariantEnum.folder_view }"
                (click)="toggleViews(DocumentViewVariantEnum.folder_view)"></i>
            </a>
            <a class="py-50 pe-75 d-flex align-content-center icon-hover justify-content-center border-end"
              placement="auto" triggers="hover"
              [ngbTooltip]="savefiltersShowHide ? 'All documents' : t('List view selection icon tooltip (documents) - List view')">
              <i class="feather font-medium-1 icon-menu"
                [ngClass]="{'activeIcons': (activeView$ | async) === DocumentViewVariantEnum.table_view && !savefiltersShowHide }"
                (click)="toggleViews(DocumentViewVariantEnum.table_view)"></i>
            </a>
            <div ngbDropdown class="border-end p-50 px-75 me-1 dropdown">
              <a ngbDropdownToggle href="javascript:void(0);" class="hide-arrow d-flex" id="todoActions"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i data-feather="more-vertical" [size]="18" class="text-body"></i>
              </a>
              <div ngbDropdownMenu class="dropdown-menu-right" aria-labelledby="todoActions">
                <a ngbDropdownItem class="sort-asc"
                  [ngClass]="{'text-muted pointer-events-none': (canUploadDocuments$ | async) === false}"
                  [disabled]="(canUploadDocuments$ | async) === false"
                  (click)="documentUploadFileModalClick()">
                  <i class="feather font-medium-3 me-50 icon-upload-cloud"></i>
                  {{ t('Upload file menu item (documents three dots menu) - Upload file') }}</a>
                @if((bulkUploadFeatureHelperService.isBulkUploadEnabled$ | async) === true){
                <a ngbDropdownItem class="sort-asc hidden" (click)="documentBulkUploadFileModalClick()">
                  <i class="feather font-medium-3 me-50 icon-upload-cloud"></i>
                  {{ t('Bulk Upload file menu item (documents three dots menu) - Bulk upload file') }}</a>
                }
                <a ngbDropdownItem class="sort-asc" (click)="openExportModal('csv')">
                  <i class="feather font-medium-3 me-50 icon-download"></i>
                  {{ t('Export CSV menu item (documents three dots menu) - Export CSV') }}</a>
                <a ngbDropdownItem class="sort-asc" (click)="openExportModal('xlsx')">
                  <i class="feather font-medium-3 me-50 icon-download"></i>
                  {{ t('Export XLSX menu item (documents three dots menu) - Export XLSX') }}</a>
                <a ngbDropdownItem class="sort-asc" (click)="toggleViews(DocumentViewVariantEnum.trash_view)">
                  <i class="feather font-medium-3 me-50 icon-trash-2"></i>
                  {{ t('Trash menu item (documents three dots menu) - Trash') }}</a>
                <a (click)="customColumnsModalClick()" ngbDropdownItem class="sort-asc">
                  <i data-feather="columns" class="font-medium-3 me-50"></i>
                  {{ t('Manage columns menu item (documents three dots menu) - Manage columns') }}</a>
              </div>
            </div>
            <div ngbDropdown>
              <button type="button" class="btn btn-success addDocumentbtn" rippleEffect ngbDropdownToggle>
                  {{t("New Document dropdown button label (Document listing) - New Document")}}
              </button>
              <div ngbDropdownMenu aria-labelledby="New document">
                  <a ngbDropdownItem (click)="createNewDocument($createdVia.DOCUMENT)">
                    {{t("Create document button label (Document listing) - Create document")}}
                  </a>
                  <a ngbDropdownItem (click)="createNewDocument($createdVia.TEMPLATE)">
                    {{t("Create signature request button label (Document listing) - Create signature request")}}
                  </a>
                  <a ngbDropdownItem (click)="generateDocument()">
                    {{t("Generate document button label (Document listing) - Generate Document")}}
                  </a>
                  <a ngbDropdownItem (click)="documentUploadFileModalClick()"
                    *ngIf="canUploadDocuments$ | async">
                    {{ t('Upload file menu item (documents three dots menu) - Upload file') }}
                  </a>
                  <a ngbDropdownItem (click)="openSelectTemplate()">
                    {{ t('Use template button label (Document listing) - Use template') }}
                  </a>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="filters-wrapper card mb-0 contractControlMainSidebar" [hidden]="!filtersShowHide">
        <!-- filter Component  -->
        <app-document-main-sidebar [activeView]="activeView$ | async"
          (showNestedChartViews)="showNestedChartViews($event)"></app-document-main-sidebar>
        <!-- filter Component  -->
      </div>


      <div class="documentListingViewMainContainer"
        *ngIf="(activeView$ | async) === DocumentViewVariantEnum.table_view">
        <!-- listing view table -->
        <app-document-listing [tableColumns$]="tableColumns$" (rowClicked) = "onRowClicked($event)"></app-document-listing>
        <!-- listing view table -->
      </div>

      <div class="documentListingViewMainContainer"
        *ngIf="(activeView$ | async) === DocumentViewVariantEnum.trash_view">
        <!-- listing view table -->
        <app-document-listing selectable="true" [tableColumns$]="tableColumns$"></app-document-listing>
        <!-- listing view table -->
      </div>

      <div class="documentFolderviewMainContainer"
        *ngIf="(activeView$ | async) === DocumentViewVariantEnum.folder_view">
        <!-- document folder view -->
        <app-document-folder-view></app-document-folder-view>
        <!-- document folder view -->
      </div>

      <div class="documentChartviewMainContainer" *ngIf="(activeView$ | async) === DocumentViewVariantEnum.graph_view">
        <!-- document graph view -->
        <app-document-graph-view></app-document-graph-view>
        <!-- document graph view -->
      </div>

      <div class="documentChartviewMainContainer" *ngIf="(activeView$ | async) === DocumentViewVariantEnum.chart_view">
        <!-- document margin graph view -->
        <app-document-margin-chart-view></app-document-margin-chart-view>
        <!-- document margin graph view -->
      </div>

      <div class="documentSaveFilterMainContainer"
        *ngIf="(activeView$ | async) === DocumentViewVariantEnum.filter_view">
        <!-- document save filters view -->
        <app-document-listing [tableColumns$]="tableColumns$"></app-document-listing>
        <!-- document save filters view -->
      </div>
    </div>
    <!--/ content-right -->

  </div>

  <!-- add-attachments-sidebar -->
  <core-sidebar class="modal modal-slide-in sidebar-todo-modal fade" name="document-right-sidebar"
    overlayClass="modal-backdrop">
    <app-document-right-sidebar></app-document-right-sidebar>
  </core-sidebar>
  <!--/ add-attachments-sidebar -->
</ng-container>
